import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from './index';

export default function renderCheckboxField({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);

  return <Checkbox validationMessage={validationMessage} isValid={isValid} {...args} {...input} />;
}

renderCheckboxField.propTypes = {
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};
